import cn from "classnames";
import React from "react";
import AddSvg from "../../../components/svgComponents/AddSvg";
import RemoveSvg from "../../../components/svgComponents/RemoveSvg";
const InputNode = ({ handleDecrement, handleIncrement, quantity }) => {
  return (
    <div className="flex gap-3 ">
      <button
        type="button"
        onClick={handleDecrement}
        className={cn(
          "w-10 h-10 md:w-17 md:h-17 rounded-lg bg-iceBlue transition-all duration-300 dark:bg-darkButBg flex items-center justify-center",
          {
            "!bg-deepBlue hover:!bg-[#8C96FF] active:!bg-[#1E31FF] border border-white shadow-swapButton":
              quantity > 1,
          }
        )}
      >
        <RemoveSvg quantity={quantity} />
      </button>
      <form className="rounded-xl">
        <label htmlFor="nodes-input" className="sr-only">
          Enter your quantity
        </label>
        <input
          value={quantity}
          readOnly
          type="text"
          className="font-inter h-10 md:h-17 bg-iceBlue dark:bg-darkButBg dark:text-white text-xl text-black rounded-lg leading-[30px] max-w-[166px] text-center focus:outline-none"
        />
      </form>
      <button
        type="button"
        onClick={handleIncrement}
        className={cn(
          "w-10 h-10 md:w-17 md:h-17 rounded-lg transition-all duration-300 bg-iceBlue dark:bg-darkButBg flex items-center justify-center",
          {
            "!bg-deepBlue hover:!bg-[#8C96FF] active:!bg-[#1E31FF] border border-white shadow-swapButton":
              quantity < 10,
          }
        )}
      >
        <AddSvg quantity={quantity} />
      </button>
    </div>
  );
};

export default InputNode;
